import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
const SHOW_MS = 5200;
const HIDE_MS = 9000;
const FIRST_DELAY_MS = 7000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo] = useState(() => Math.floor(Math.random() * 6) + 2);
  useEffect(() => {
    if (dismissed) return;
    let timeout: number;
    const show = () => {
      setVisible(true);
      timeout = window.setTimeout(hide, SHOW_MS);
    };
    const hide = () => {
      setVisible(false);
      timeout = window.setTimeout(() => {
        setIndex(prev => (prev + 1) % purchaseNotifications.length);
        show();
      }, HIDE_MS);
    };
    timeout = window.setTimeout(show, FIRST_DELAY_MS);
    return () => window.clearTimeout(timeout);
  }, [dismissed]);
  if (dismissed) return null;
  const person = purchaseNotifications[index];
  return <AnimatePresence data-id="element-40" data-mp="117fsm8rns5ui">
      {visible ? <motion.aside initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} aria-live="polite" className="fixed bottom-40 left-3 right-3 z-30 mx-auto max-w-sm rounded-2xl border border-teal-400/25 bg-white p-3 shadow-[0_18px_40px_-16px_rgba(4,18,27,0.65)] sm:bottom-36 sm:left-4 sm:right-auto" data-id="element-41" data-mp="116cylrz1hnad">
          <div className="flex items-start gap-3" data-id="element-42" data-mp="x6vtizniys5q">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-teal-50" data-id="element-43" data-mp="s5omj2t7hx04">
              <CheckCircle2Icon className="h-5 w-5 text-teal-600" aria-hidden="true" data-id="element-44" data-mp="28joi61l0r0hk" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-45" data-mp="23kblkp4cif1s">
              <p className="text-sm font-bold leading-snug text-ink-900" data-id="element-46" data-mp="23nhb25gvziy1">{person.name}</p>
              <p className="text-[13px] leading-snug text-ink-600" data-id="element-47" data-mp="2aobbwi679qtv">
                just purchased the <span className="font-semibold" data-id="element-48" data-mp="2fm365iubhp18">Master System of TRT™</span>
              </p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.1em] text-teal-600" data-id="element-49" data-mp="2knaebj0dgq8f">
                {person.country} · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="-mr-1 -mt-1 rounded-lg p-1.5 text-ink-500/60 transition-colors duration-150 ease-out hover:bg-paper-100 hover:text-ink-900" data-id="element-50" data-mp="1rzei0fept0c6">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-51" data-mp="26oj0zytc38lc" />
            </button>
          </div>
        </motion.aside> : null}
    </AnimatePresence>;
}